let stickyConfig = {}

export default {
  mounted(el, binding, vnode) {
    stickyConfig = binding.value || {}
    const divTop = el.offsetTop ?? 0 + (stickyConfig.offsetTop || 0)
    const divBottom = el.offsetBottom ?? 0 + (stickyConfig.offsetBottom || 0)

    const checkScroll = () => {
      const shouldAddStickClass = stickyConfig.enabled
      const stickyPartExceedBottom = window.screen.availHeight >= divBottom
      const windowTopUnderStickyPart = window.scrollY > divTop
      if (windowTopUnderStickyPart === true && shouldAddStickClass === true && stickyPartExceedBottom === true) {
        el.classList.add('sticky')
        if (stickyConfig.getParentElementWidth === true) {
          const rightPadding = parseInt(
            window.getComputedStyle(vnode.el.parentNode).getPropertyValue('padding-right'),
            10
          )
          const leftPadding = parseInt(
            window.getComputedStyle(vnode.el.parentNode).getPropertyValue('padding-left'),
            10
          )
          el.style.width = vnode.el.parentNode.getBoundingClientRect().width - (rightPadding + leftPadding) + 'px'
        }
      } else {
        el.classList.remove('sticky')
        if (stickyConfig.getParentElementWidth === true) {
          el.style.width = ''
        }
      }
    }

    window.addEventListener('scroll', checkScroll)

    el.$destroy = () => {
      window.removeEventListener('scroll', checkScroll)
    }
  },
  updated(el, binding) {
    stickyConfig = binding.value || {}
    if (stickyConfig.enabled === false) {
      el.classList.remove('sticky')
    }
  },
  unmounted(el) {
    if (el.$destroy) {
      el.$destroy()
    }
  }
}
